import AuthWrapper from 'components/AuthWrapper';
import BlockingSpinnerOverlay from 'components/BlockingSpinnerOverlay';
import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import locationShape from 'shapes/locationShape';
import identityClient from '../../../clients/identityClient';
import errorMessages from '../../../helpers/errorMessages';
import { error as err } from '../../NewRegistrationFlow/PreSignUp';
import ErrorAlert from '../../NewRegistrationFlow/PreSignUp/ErrorAlert';
import AuthWrapperSecondary from '../../Verify/AuthWrapperSecondary';
import HpaStoreContext from '../../../contexts/HpaStoreContext';

const MatchFound = ({ location }) => {
    const [error, setError] = useState(err);
    const [loading, setLoading] = useState(false);
    const [isMobileRequired, setIsMobileRequired] = useState(false);
    const [isConfigLoading, setIsConfigLoading] = useState(true);
    const history = useHistory();
    const context = useContext(HpaStoreContext);
    const params = new URLSearchParams(window.location.search);
    const { isConfirmed, hStreamId, username, workflowType, firstName, lastName, mobileNumberExists } = location?.state;

    useEffect(() => {
        setIsConfigLoading(true);
        let isMobileRequiredForLinking = false;
        try {
            const tenantId = params.get('tenantid');
            if (tenantId) {
                const tenantVal = context?.customBranding?.find((item) => item.name === 'IsMobileNumberRequiredForLinking')?.value;
                isMobileRequiredForLinking = tenantVal === true || tenantVal === 'true';
            } else {
                const appVal = context?.config?.IsMobileNumberRequiredForLinking;
                if (appVal !== undefined) {
                    isMobileRequiredForLinking = appVal === true || appVal === 'true';
                } else {
                    const customBrandingVal = context?.customBranding?.find((item) => item.name === 'IsMobileNumberRequiredForLinking');
                    const entryVal = customBrandingVal?.value;
                    isMobileRequiredForLinking = entryVal === true || entryVal === 'true';
                }
            }
        } catch (e) {
            console.warn('Error determining mobile requirement for MatchFound', e);
        } finally {
            setIsMobileRequired(isMobileRequiredForLinking);
            setIsConfigLoading(false);
        }
    }, [context?.config, context?.customBranding, params]);

    const onCancelRegister = () => {
        history.push({
            pathname: '/account/link',
            search: location.search,
            state: { email: '' },
        });
    };

    const onContinue = async () => {
        try {
            setLoading(true);
            await identityClient.sendRegistrationOTP(
                username,
                hStreamId,
                undefined,
                workflowType,
            );
            history.push({
                pathname: '/account/link/confirm',
                state: {
                    email: username,
                    hStreamId: hStreamId,
                    workflowType,
                    isConfirmed: isConfirmed,
                    isProvisioned: false,
                    firstName: firstName,
                    lastName: lastName,
                    isMobileRequired: isMobileRequired,
                    mobileNumberExists: mobileNumberExists,
                },
                search: window.location.search,
            });
        } catch (e) {
            setError({
                ...error,
                errorFound: true,
                errorMessage: (e.response?.data?.status === 400 || e.response?.data?.status === 409) ? e.response?.data?.detail : errorMessages?.processing?.message,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthWrapper
            secondary={<AuthWrapperSecondary />}
        >
            {error?.errorFound && <ErrorAlert error={error} />}
            <div
                className="position-relative"
                aria-busy={(loading || isConfigLoading) || undefined}
            >
                <BlockingSpinnerOverlay
                    show={loading}
                    ariaLabel="Loading..."
                />
                <p className="AuthWrapper__register__fontsize">
                    <div className="font-weight-bold pb-1 AuthWrapper__register__wordbreak">Great, we found an hStream ID for:</div> <p className="AuthWrapper__register__wordbreak">{username}</p>
                </p>
                <div>
                    <Row className="py-3 d-flex align-items-center">
                        <Col sm="9">
                            <div className="AuthWrapper__register__fontsize font-weight-bold">Let's confirm your identity next</div>
                        </Col>
                        <Col sm="3">
                            <Button id="matchFound" color="primary" block className="btn btn-sm float-right" onClick={onContinue} disabled={loading || isConfigLoading}>
                                {loading || isConfigLoading ? 'Loading...' : 'Continue'}</Button>
                        </Col>
                    </Row>
                </div>
                <hr />
                <Button
                    id="tryDifferentEmail"
                    color="link"
                    type="button"
                    className="btn btn-sm p-0"
                    disabled={loading || isConfigLoading}
                    onClick={onCancelRegister}
                >
                    Try a different email
                </Button>
            </div>
        </AuthWrapper>
    );
};

MatchFound.propTypes = {
    location: locationShape.isRequired,
};

export default MatchFound;
